/* eslint-disable import/no-anonymous-default-export */
import {
  PLATFORM_CLEAR_MENU_ITEMS,
  PLATFORM_CLEAR_MENU_ITEMS_CATALOG,
  PLATFORM_CLEAR_PLATFORMS,
  PLATFORM_CLEAR_PRODUCT_GROUPS,
  PLATFORM_CLEAR_PRODUCT_GROUPS_CATALOG,
  PLATFORM_FETCH_MENU_ITEM,
  PLATFORM_FETCH_MENU_ITEMS,
  PLATFORM_FETCH_MENU_ITEMS_CATALOG,
  PLATFORM_FETCH_MENU_ITEMS_FILTERED,
  PLATFORM_FETCH_PLATFORMS,
  PLATFORM_FETCH_PRODUCT_GROUPS,
  PLATFORM_FETCH_PRODUCT_GROUPS_FILTERED,
  PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE
} from "../action-types/platforms-types";

const initialState = {
  item: {},
  categories: [],
  rowData: {},
  groups: [],
  groupsCatalog: [],
  items: [],
  itemsCatalog: [],
  loading: false,
  rejected: false,
  total: 0,
  page: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PLATFORM_FETCH_PLATFORMS.REQUEST:
    case PLATFORM_FETCH_PRODUCT_GROUPS.REQUEST:
    case PLATFORM_FETCH_MENU_ITEMS.REQUEST:
    case PLATFORM_FETCH_MENU_ITEM.REQUEST:
    case PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE.REQUEST:
      return {
        ...state,
        loading: true,
        rejected: false,
      };
    case PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE.SUCCESS:
    case PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE.REJECTED:
      return {
        ...state,
        loading: true
      };
    case PLATFORM_FETCH_PLATFORMS.SUCCESS:
      return {
        ...state,
        categories:
          action.payload.data.pagination.page > 1
            ? [...state.categories, ...action.payload.data['product-categories']]
            : [...action.payload.data['product-categories']],
        total: action.payload.data.pagination.total,
        page: action.payload.data.pagination.page,
        loading: false,
        rejected: false,
      };
    case PLATFORM_FETCH_PLATFORMS.REJECTED:
    case PLATFORM_FETCH_PRODUCT_GROUPS.REJECTED:
    case PLATFORM_FETCH_MENU_ITEMS.REJECTED:
    case PLATFORM_FETCH_MENU_ITEM.REJECTED:
      return {
        ...state,
        loading: false,
        rejected: true,
      };
    case PLATFORM_FETCH_PRODUCT_GROUPS.SUCCESS:
      return {
        ...state,
        groupsCatalog: [...action.payload.data],
        loading: false,
        rejected: false,
      };
    case PLATFORM_FETCH_PRODUCT_GROUPS_FILTERED.SUCCESS:
      return {
        ...state,
        groups: action.payload.idCategory
          ? [...state.groups, ...action.payload.data]
          : [...action.payload.data],
        loading: false,
        rejected: false,
      };
    case PLATFORM_CLEAR_PLATFORMS:
      return {
        ...state,
        groups: [],
        categories: [],
        items: [],
        loading: false,
        rejected: false,
      }
    case PLATFORM_FETCH_MENU_ITEMS.SUCCESS:
      return {
        ...state,
        items: [...state.items, ...action.payload.data],
        loading: false,
        rejected: false,
      };
    case PLATFORM_FETCH_MENU_ITEMS_FILTERED.SUCCESS:
      return {
        ...state,
        items:
          action.payload.page > 1 || action.payload.group > 0
            ? [...state.items, ...action.payload.data]
            : [...action.payload.data],
        loading: false,
        rejected: false,
      };
    case PLATFORM_FETCH_MENU_ITEM.SUCCESS:
      return {
        ...state,
        item: { ...action.payload.data },
        loading: false,
        rejected: false,
      };
    case PLATFORM_FETCH_MENU_ITEMS_CATALOG.SUCCESS:
      return {
        ...state,
        itemsCatalog: [...action.payload.data],
        loading: false,
        rejected: false,
      };
    case PLATFORM_CLEAR_PRODUCT_GROUPS:
      return {
        ...state,
        groups: [],
        loading: false,
        rejected: false,
      };
    case PLATFORM_CLEAR_MENU_ITEMS:
      return {
        ...state,
        items: [],
        loading: false,
        rejected: false,
      };
    case PLATFORM_CLEAR_PRODUCT_GROUPS_CATALOG:
      return {
        ...state,
        groupsCatalog: [],
        loading: false,
        rejected: false,
      };
    case PLATFORM_CLEAR_MENU_ITEMS_CATALOG:
      return {
        ...state,
        itemsCatalog: [],
        loading: false,
        rejected: false,
      };
    default:
      return { ...state };
  }
}
